/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MexcoreapipbAddEcomMigrationActionsRequest {
  merchantGroupID: string
  actions: MexcoreapipbEcomMigrationActionInput[]
  actionVersion: string
}

export interface MexcoreapipbAddEcomMigrationActionsResponse {
  actions: MexcoreapipbEcomMigrationAction[]
  actionVersion: string
}

export interface MexcoreapipbAttributeCluster {
  attributeClusterID: string
  name: string
  nameLocalization: MexcoreapipbLocalization[]
  businessType: string
  status: string
  icon: string
  attributeClusterType: string
  attributeClusterOptions: MexcoreapipbAttributeClusterOptions[]
  metadata: MexcoreapipbAttributeClusterMetadata
  /** @format int64 */
  version: number
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
}

export interface MexcoreapipbAttributeClusterMetadata {
  /** @format int32 */
  attributesLimitPerItem: number
  booleanMetadata: MexcoreapipbBooleanMetadata
  integerMetadata: MexcoreapipbIntegerMetadata
  decimalMetadata: MexcoreapipbDecimalMetadata
  freeTextMetadata: MexcoreapipbFreeTextMetadata
}

export interface MexcoreapipbAttributeClusterOptions {
  /** @format int64 */
  countryID: number
  isMandatory: boolean
  isShownToPax: boolean
  isMexSelfServe: boolean
  isSearchKeywordEnabled: boolean
  isFilterOptionEnabled: boolean
  /** @format int64 */
  version: number
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  attributeClusterOptionID: string
  isVariantSelectorEnabled: boolean
}

export interface MexcoreapipbBatchUpdateCategoriesRequest {
  merchantID: string
  categories: MexcoreapipbCategory[]
}

export interface MexcoreapipbBatchUpdateCategoriesResponse {
  /** @format int32 */
  updatedCount: number
  updatedCategoryIDs: string[]
}

export interface MexcoreapipbBooleanMetadata {
  defaultValue: boolean
}

export interface MexcoreapipbCategory {
  categoryID: string
  merchantID: string
  sectionID: string
  name: string
  /** @format int32 */
  cmplxSortOrder: number
  status: string
  /** @format date-time */
  availableAt: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  externalID: string
  propagateID: string
  markdownMeta: string
  /** @format int64 */
  version: number
  /** @format int64 */
  maxHandlingTime: number
  isMenuEntity: boolean
}

export interface MexcoreapipbCategoryTreeNode {
  categoryTreeNodeID: string
  parentID: string
  name: string
  hierarchy: string
  /** @format int32 */
  level: number
  /** @format int32 */
  sortOrder: number
  status: string
  /** @format int32 */
  businessType: number
  metadata: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  translation: Record<string, string>
  icon: string
  /** @format int64 */
  countryID: number
  attributeClusters: MexcoreapipbCategoryTreeNodeAttributeCluster[]
  hierarchyName: string
  leafNode: boolean
  localizedName: string
  localizedHierarchyName: string
}

export interface MexcoreapipbCategoryTreeNodeAttributeCluster {
  attributeCluster: MexcoreapipbAttributeCluster
  status: string
  isGlobal: boolean
}

export interface MexcoreapipbCreateCategoryRequest {
  merchantID: string
  category: MexcoreapipbCategory
}

export interface MexcoreapipbCreateCategoryResponse {
  category: MexcoreapipbCategory
}

export interface MexcoreapipbCreateProductItemsRequest {
  merchantID: string
  productSpu: MexcoreapipbProductSpu
  productSpuAttributeValues: MexcoreapipbProductSpuAttributeValue[]
  ecomItemAndAttributes: MexcoreapipbEcomItemDetail[]
  categoryTreeNodeID: string
  videoID: string
}

export interface MexcoreapipbCreateProductItemsResponse {
  productSpuID: string
}

export interface MexcoreapipbDecimalMetadata {
  min: MexcoreapipbNilableInt32
  max: MexcoreapipbNilableInt32
  numberOfDecimalPlaces: MexcoreapipbNilableInt32
  units: string
  unitLocalizations: MexcoreapipbLocalization[]
}

export interface MexcoreapipbDimensionAttribute {
  /** @format float */
  width: number
  /** @format float */
  height: number
  /** @format float */
  length: number
  unit: string
}

export interface MexcoreapipbDownloadBulkUploadTemplateRequest {
  uploadType: string
  merchantIDs: string[]
}

export interface MexcoreapipbDownloadBulkUploadTemplateResponse {
  presignedURL: string
}

/** === EcomItem DTOs - E-commerce item (SKU/variant) related */
export interface MexcoreapipbEcomItem {
  itemID: string
  productSpuID: string
  availableStatus: string
  currency: string
  description: string
  merchantID: string
  name: string
  status: string
  /** @format date-time */
  availableAt: string
  /** @format int32 */
  sortOrder: number
  /** @format int32 */
  capacity: number
  /** @format int32 */
  discountInCent: number
  icons: string
  photos: string
  tagIDs: string
  oldCategories: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  categoryID: string
  /** @format int64 */
  priceInMin: number
  /** @format int32 */
  cmplxSortOrder: number
  externalID: string
  metadata: string
  /** @format int64 */
  version: number
  /** @format int32 */
  portion: number
  propagateID: string
  itemClassID: string
  specialItemType: string
  tags: string
  collectionIDs: string
  skuID: string
  brandName: string
  /** @format int32 */
  maxStock: number
  /** @format int32 */
  availableDaysInWeek: number
  placeOfOrigin: string
  dietarySpecifications: string
  storage: string
  sellingTimeID: string
  customisedData: string
  weight: MexcoreapipbWeightAttribute
  dimension: MexcoreapipbDimensionAttribute
}

export interface MexcoreapipbEcomItemAttributeValue {
  itemID: string
  attributeID: string
  ecomItemAttributeValueID: string
  value: string
  status: string
  /** @format int64 */
  version: number
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  attributeClusterID: string
  metadata: string
}

/** EcomItemDetail is a same view of an EcomItem, with attributes included */
export interface MexcoreapipbEcomItemDetail {
  itemID: string
  productSpuID: string
  availableStatus: string
  currency: string
  description: string
  merchantID: string
  name: string
  status: string
  /** @format date-time */
  availableAt: string
  /** @format int32 */
  sortOrder: number
  /** @format int32 */
  capacity: number
  /** @format int32 */
  discountInCent: number
  icons: string
  photos: string
  tagIDs: string
  oldCategories: string
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  categoryID: string
  /** @format int64 */
  priceInMin: number
  /** @format int32 */
  cmplxSortOrder: number
  externalID: string
  metadata: string
  /** @format int64 */
  version: number
  /** @format int32 */
  portion: number
  propagateID: string
  itemClassID: string
  specialItemType: string
  tags: string
  collectionIDs: string
  skuID: string
  brandName: string
  /** @format int32 */
  maxStock: number
  /** @format int32 */
  availableDaysInWeek: number
  placeOfOrigin: string
  dietarySpecifications: string
  storage: string
  sellingTimeID: string
  customisedData: string
  ecomItemAttributeValues: MexcoreapipbEcomItemAttributeValue[]
  /** @format int32 */
  currentStock: number
  weight: MexcoreapipbWeightAttribute
  dimension: MexcoreapipbDimensionAttribute
  locationStocks: MexcoreapipbLocationStock[]
  storeItemInfo: MexcoreapipbOutletItemInfo
}

export interface MexcoreapipbEcomItemSearchResult {
  itemID: string
  itemName: string
  /** @format int64 */
  priceInMin: number
  /** @format int32 */
  stock: number
  status: string
  photos: string[]
  skuID: string
  externalID: string
}

export interface MexcoreapipbEcomMigrationAction {
  actionType: string
  targetID: string
  payload: MexcoreapipbEcomMigrationActionPayload
  /** @format int64 */
  sequence: number
  createdAt: string
}

/** EcomMigrationActionInput deliberately excludes CMS-owned lifecycle/audit fields. */
export interface MexcoreapipbEcomMigrationActionInput {
  actionType: string
  targetID: string
  payload: MexcoreapipbEcomMigrationActionPayload
}

export interface MexcoreapipbEcomMigrationActionPayload {
  name: string
}

/**
 * EcomMigrationStatus mirrors cms-bulk-upload EcomMigrationStatus value names and numbers,
 * so the JSON string the portal sees is identical across both services.
 * @default "ECOM_MIGRATION_STATUS_UNSPECIFIED"
 */
export enum MexcoreapipbEcomMigrationStatus {
  ECOM_MIGRATION_STATUS_UNSPECIFIED = "ECOM_MIGRATION_STATUS_UNSPECIFIED",
  NOT_READY = "NOT_READY",
  PENDING_REVIEW = "PENDING_REVIEW",
  SCHEDULED = "SCHEDULED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  SCHEDULING = "SCHEDULING",
}

export interface MexcoreapipbEcomProductSpuSearchResult {
  productSpuID: string
  productSpuName: string
  /** @format int64 */
  minPriceInMin: number
  /** @format int64 */
  maxPriceInMin: number
  /** @format int32 */
  stock: number
  status: string
  items: MexcoreapipbEcomItemSearchResult[]
  photos: string[]
}

export interface MexcoreapipbFreeTextMetadata {
  /** @format int32 */
  maxLength: number
}

export interface MexcoreapipbGetEcomMigrationActionsResponse {
  actions: MexcoreapipbEcomMigrationAction[]
  actionVersion: string
}

export interface MexcoreapipbGetEcomMigrationCSVResponse {
  /** Eng spec: snapshot_id is the stable merchant_group_id (not a generation id). */
  snapshotID: string
  presignedURL: string
  /** @format date-time */
  expiresAt: string
  /** @format date-time */
  lastModifiedAt: string
  /** Fields 5-10 are passed through from cms-bulk-upload GetEcomMigrationCSV (same field numbers). */
  migrationStatus: MexcoreapipbEcomMigrationStatus
  actionsAllowed: boolean
  /** @format date-time */
  scheduledRunAt: string
  /**
   * When Chimera first generated the plan; null if first_created_at.json is not written yet.
   * @format date-time
   */
  firstCreatedAt: string
  /**
   * End of the merchant review window (firstCreatedAt + 30 days, computed by cms-bulk-upload); null when firstCreatedAt is null.
   * @format date-time
   */
  reviewEndAt: string
  /**
   * Size of the migration plan CSV in MB rounded to 2 decimal places, computed by cms-bulk-upload.
   * @format double
   */
  fileSize: number
}

export interface MexcoreapipbGetItemsByProductIDsResponse {
  /** EcomItems ordered by ProductSpuID, with items from the same ProductSpuID grouped together */
  ecomItems: MexcoreapipbEcomItemDetail[]
  seek: string
}

export interface MexcoreapipbGetProductByIDResponse {
  product: MexcoreapipbProductSpu
  productSpuAttributeValues: MexcoreapipbProductSpuAttributeValue[]
  ecomItemDetail: MexcoreapipbEcomItemDetail[]
  categoryTreeNodeID: string
}

export interface MexcoreapipbGetProductVideoStatusResponse {
  videoID: string
  state: string
  videoCDNLink: string
  videoS3URL: string
  thumbnailURL: string
}

export interface MexcoreapipbGetProductVideoUploadURLResponse {
  presignedURL: string
  videoID: string
}

export interface MexcoreapipbIntegerMetadata {
  min: MexcoreapipbNilableInt32
  max: MexcoreapipbNilableInt32
  units: string
  unitLocalizations: MexcoreapipbLocalization[]
}

export interface MexcoreapipbListCategoriesResponse {
  categories: MexcoreapipbCategory[]
  more: boolean
}

export interface MexcoreapipbListCategoryTreeNodesResponse {
  categoryTreeNodes: MexcoreapipbCategoryTreeNode[]
}

export interface MexcoreapipbListOutletItemInfoRequest {
  productSpuID: string
  itemID: string
  merchantIDs: string[]
  merchantNamePrefix: string
  /** @format int32 */
  limit: number
  cursor: string
}

export interface MexcoreapipbListOutletItemInfoResponse {
  items: MexcoreapipbOutletItemInfo[]
  cursor: string
}

export interface MexcoreapipbListProductsByCategoryIDResponse {
  products: MexcoreapipbProductSpu[]
  seek: string
}

export interface MexcoreapipbListProductsResponse {
  products: MexcoreapipbProductSpu[]
  seek: string
}

export interface MexcoreapipbLocalization {
  languageCode: string
  value: string
  aiTranslated: boolean
}

/**
 * Stock row at a single outlet (clone ecom_item); not the template row.
 * To make merchant_id & item_id mandatory after migration
 */
export interface MexcoreapipbLocationStock {
  merchantID: string
  itemID: string
  /** @format int32 */
  maxStock: number
}

export interface MexcoreapipbNilableInt32 {
  /** @format int32 */
  value: number
}

export interface MexcoreapipbOutletItemInfo {
  merchantID: string
  merchantName: string
  itemID: string
  productSpuID: string
  itemName: string
  /** @format int64 */
  maxStock: number
  /** @format int64 */
  priceInMin: number
  status: string
}

export interface MexcoreapipbOutletItemInfoUpdate {
  merchantID: string
  itemID: string
  /** @format int64 */
  maxStock: number
  /** @format int64 */
  priceInMin: number
  status: string
  /**
   * Fields to apply from this row: "maxStock", "priceInMin", "status". Unlisted fields are
   * ignored and filled from the current outlet item; delv stock sync only when "maxStock" is listed.
   */
  updatedFields: string[]
}

export interface MexcoreapipbOutletItemInfoUpdateKey {
  merchantID: string
  itemID: string
}

/** === ProductSpu DTOs - E-commerce product SPU related */
export interface MexcoreapipbProductSpu {
  productSpuID: string
  merchantID: string
  name: string
  nameLocalization: string
  description: string
  descriptionLocalization: string
  variantSelectorClusters: string
  status: string
  metadata: string
  /** @format int64 */
  version: number
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  /** @format date-time */
  deletedAt: string
  photos: string
  collectionIDs: string
  categoryIDs: string
  videos: string
}

export interface MexcoreapipbProductSpuAttributeValue {
  productSpuID: string
  attributeID: string
  productSpuAttributeValueID: string
  value: string
  status: string
  /** @format int64 */
  version: number
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  attributeClusterID: string
  metadata: string
}

export interface MexcoreapipbSearchEcomProductSpusRequest {
  merchantID: string[]
  query: string
  statuses: string[]
  categoryIDs: string[]
  sortBy: string
  asc: boolean
  /** @format int32 */
  limit: number
  cursor: string
  /** @format date-time */
  availableAt: string
}

export interface MexcoreapipbSearchEcomProductSpusResponse {
  items: MexcoreapipbEcomProductSpuSearchResult[]
  cursor: string
  /** @format int64 */
  totalHits: number
}

export interface MexcoreapipbUpdateCategoryProductsRequest {
  merchantID: string
  categoryID: string
  productSpuIDs: string[]
}

export interface MexcoreapipbUpdateCategoryProductsResponse {
  /** @format int32 */
  updatedCount: number
  updatedProductSpuIDs: string[]
}

export interface MexcoreapipbUpdateCategoryRequest {
  categoryID: string
  merchantID: string
  category: MexcoreapipbCategory
}

export interface MexcoreapipbUpdateItemRequest {
  itemID: string
  merchantID: string
  status: string
}

export interface MexcoreapipbUpdateOutletItemInfoRequest {
  items: MexcoreapipbOutletItemInfoUpdate[]
}

export interface MexcoreapipbUpdateOutletItemInfoResponse {
  /** @format int32 */
  updatedCount: number
  items: MexcoreapipbOutletItemInfoUpdateKey[]
}

export interface MexcoreapipbUpdateProductItemsRequest {
  merchantID: string
  productSpuID: string
  productSpu: MexcoreapipbProductSpu
  productSpuAttributeValues: MexcoreapipbProductSpuAttributeValue[]
  ecomItemAndAttributes: MexcoreapipbEcomItemDetail[]
  categoryTreeNodeID: string
  videoID: string
}

export interface MexcoreapipbUpdateProductItemsResponse {
  productSpu: MexcoreapipbProductSpu
  productSpuAttributeValues: MexcoreapipbProductSpuAttributeValue[]
  ecomItems: MexcoreapipbEcomItem[]
  ecomItemAttributeValues: MexcoreapipbEcomItemAttributeValue[]
  softDeletedItemIDs: string[]
  softDeletedProductSpuAttributeValueIDs: string[]
}

export interface MexcoreapipbUpdateProductItemsStatusByIDRequest {
  productSpuID: string
  status: string
}

export interface MexcoreapipbWeightAttribute {
  /** @format float */
  weight: number
  unit: string
}

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 *
 * In its binary encoding, an `Any` is an ordinary message; but in other wire
 * forms like JSON, it has a special encoding. The format of the type URL is
 * described on the `type_url` field.
 *
 * Protobuf APIs provide utilities to interact with `Any` values:
 *
 * - A 'pack' operation accepts a message and constructs a generic `Any` wrapper
 *   around it.
 * - An 'unpack' operation reads the content of an `Any` message, either into an
 *   existing message or a new one. Unpack operations must check the type of the
 *   value they unpack against the declared `type_url`.
 * - An 'is' operation decides whether an `Any` contains a message of the given
 *   type, i.e. whether it can 'unpack' that type.
 *
 * The JSON format representation of an `Any` follows one of these cases:
 *
 * - For types without special-cased JSON encodings, the JSON format
 *   representation of the `Any` is the same as that of the message, with an
 *   additional `@type` field which contains the type URL.
 * - For types with special-cased JSON encodings (typically called 'well-known'
 *   types, listed in https://protobuf.dev/programming-guides/json/#any), the
 *   JSON format representation has a key `@type` which contains the type URL
 *   and a key `value` which contains the JSON-serialized value.
 *
 * The text format representation of an `Any` is like a message with one field
 * whose name is the type URL in brackets. For example, an `Any` containing a
 * `foo.Bar` message may be written `[type.googleapis.com/foo.Bar] { a: 2 }`.
 */
export interface ProtobufAny {
  /**
   * Identifies the type of the serialized Protobuf message with a URI reference
   * consisting of a prefix ending in a slash and the fully-qualified type name.
   *
   * Example: type.googleapis.com/google.protobuf.StringValue
   *
   * This string must contain at least one `/` character, and the content after
   * the last `/` must be the fully-qualified name of the type in canonical
   * form, without a leading dot. Do not write a scheme on these URI references
   * so that clients do not attempt to contact them.
   *
   * The prefix is arbitrary and Protobuf implementations are expected to
   * simply strip off everything up to and including the last `/` to identify
   * the type. `type.googleapis.com/` is a common default prefix that some
   * legacy implementations require. This prefix does not indicate the origin of
   * the type, and URIs containing it are not expected to respond to any
   * requests.
   *
   * All type URL strings must be legal URI references with the additional
   * restriction (for the text format) that the content of the reference
   * must consist only of alphanumeric characters, percent-encoded escapes, and
   * characters in the following set (not including the outer backticks):
   * `/-.~_!$&()*+,;=`. Despite our allowing percent encodings, implementations
   * should not unescape them to prevent confusion with existing parsers. For
   * example, `type.googleapis.com%2FFoo` should be rejected.
   *
   * In the original design of `Any`, the possibility of launching a type
   * resolution service at these type URLs was considered but Protobuf never
   * implemented one and considers contacting these URLs to be problematic and
   * a potential security issue. Do not attempt to contact type URLs.
   */
  typeUrl: string
  /**
   * Holds a Protobuf serialization of the type described by type_url.
   * @format byte
   */
  value: string
}

export interface RuntimeError {
  error: string
  /** @format int32 */
  code: number
  message: string
  details: ProtobufAny[]
}
